// extracted by mini-css-extract-plugin
export default {"loader":"index_loader_VJFJw","spinner":"index_spinner_n8fns"};